export type PasswordStrength = 'weak' | 'medium' | 'strong' | null;

export interface PasswordComplexity {
  strength: PasswordStrength;
  message: string;
}

const defaultHelperText =
  'Password must be at least 8 characters long and include uppercase, lowercase, numbers, and special characters.';

export function checkPasswordStrength(
  password: string,
  weakPasswordMessage = 'Password is too weak',
  strongPasswordMessage = 'Password is very strong',
  mediumPasswordMessage = 'Password is good, but could be stronger.',
): PasswordComplexity {
  if (password.length === 0) {
    return {
      strength: null,
      message: defaultHelperText,
    };
  }

  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumbers = /\d/.test(password);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
  const isLongEnough = password.length >= 8;

  const score = [hasUpperCase, hasLowerCase, hasNumbers, hasSpecialChar, isLongEnough].filter(
    Boolean,
  ).length;

  if (score < 4) {
    return {
      strength: 'weak',
      message: weakPasswordMessage,
    };
  }

  if (score < 5) {
    return {
      strength: 'medium',
      message: mediumPasswordMessage,
    };
  }

  return {
    strength: 'strong',
    message: strongPasswordMessage,
  };
}
